import React from 'react';
import { Layout } from 'antd';
import Sidebar from 'components/Sidebar/Sidebar';
import { RouteRedirect } from '@unicus/react-ui-kit';
import 'components/IconLibrary';
import InsideHeader from 'components/Topbar/InsideHeader';
import useSubscription from 'core/hooks/useSubscription';
import UploadRegistrationStatementModal from 'pages/shared/UploadRegistrationStatementModal';
import useAuth from 'core/hooks/useAuth';
import { Routes } from 'components/routes';
import { SUBSCRIPTION_MANAGER_ROLES } from 'constants/types';

const { Content } = Layout;

const AppContainer = (props) => {
  const { match, routes, roles, basePath, restrictRoles = [] } = props;
  const {
    isAuthenticated,
    isAdmin,
    isMultiTenant,
    isMultiCompany,
    user,
    tenantId,
    company,
    hasRole
  } = useAuth();
  const { isActivated, hasLicense } = useSubscription();

  const onBeforeRouteRender = ({ route }) => {
    if (isAuthenticated && isAdmin() && !tenantId) {
      return <RouteRedirect to="/a" />;
    }

    if (
      isAuthenticated &&
      (isMultiTenant || isMultiCompany) &&
      (!tenantId || !company)
    ) {
      return <RouteRedirect to="/accounts-chooser" />;
    }

    if (!isAuthenticated) {
      return <RouteRedirect to="/signout" />;
    }

    if (
      !isActivated &&
      hasLicense &&
      route?.path !== '/expired-license' &&
      route?.path !== '/subscriptions'
    ) {
      return <RouteRedirect to="/app/expired-license" />;
    }

    if (
      !isActivated &&
      route?.path !== '/subscriptions' &&
      route?.path !== '/expired-license'
    ) {
      const allowedRoutes =
        !isAdmin() && user.hasTreatmentInvite
          ? ['/patients', '/:id/history']
          : [];

      if (!allowedRoutes.some((c) => route.path.startsWith(c))) {
        // Só manda para /app/subscriptions quem pode abrir essa rota. Quem não
        // pode era devolvido pelo RestrictedRoute ao defaultPath do papel, que
        // caía aqui de novo — loop infinito e tela branca. Ex.: contador ia
        // parar em /app/settings/accountings e voltava para cá sem fim.
        return hasRole(...SUBSCRIPTION_MANAGER_ROLES) ? (
          <RouteRedirect to="/app/subscriptions" />
        ) : (
          <RouteRedirect to="/app/expired-license" />
        );
      }
    }

    return null;
  };

  return (
    <Layout className="gx-app-layout">
      <UploadRegistrationStatementModal />
      <Sidebar routes={routes} match={match} />
      <Layout>
        <InsideHeader routes={routes} match={match} />
        <Content
          id="main-container"
          className="gx-layout-content gx-container-wrap"
        >
          <div className="gx-main-content-wrapper">
            <Routes
              match={match}
              routes={routes}
              roles={roles}
              basePath={basePath}
              restrictRoles={restrictRoles}
              onBeforeRouteRender={onBeforeRouteRender}
              isContainer
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppContainer;
